module.exports = __webpack_public_path__ + "static/media/publish.c5d53a4c.svg";